const globalSiteHeader = {
  displayField: 'title',
  name: 'Global Site Header',
  description: '',
  fields: [
    {
      id: 'title',
      name: 'title',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'topLevelNav',
      name: 'Top Level Nav',
      type: 'Array',
      localized: false,
      required: true,
      validations: [],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'navLink' ] } ],
        linkType: 'Entry'
      }
    }
  ],
  sys: {
    id: 'globalSiteHeader',
    version: 10,
    updatedAt: '2023-05-09T15:30:05.645Z'
  }
};
export default globalSiteHeader;